<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :toolbar-config="{
      slots: {
        buttons: 'toolbar_form',
      },
    }"
    :columns="tableColumns"
    :loading="loading"
    size="small"
    resizable
    border
    :height="235"
    :header-cell-style="
      () => {
        return {
          backgroundColor: '#bd94c1',
          color: '#ffffff',
        }
      }
    "
  >
    <template v-slot:toolbar_form>
      <slot name="header"></slot>
    </template>
    <template v-slot:specInfo="{ row }">
      <span>{{ row.spec }} {{ row.specUnit }}</span>
    </template>
    <template v-slot:defaultImageUrl="{ row }">
      <el-image
        :src="
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg'
        "
        style="width:100px; height:66px"
        :preview-src-list="[
          row.defaultImageUrl
            ? $osscdn(row.defaultImageUrl)
            : '/image/static/img/nopic.jpg',
        ]"
      >
        <div slot="error" class="image-slot">
          <img
            src="/image/static/img/nopic.jpg"
            style="width: 100px; height: 66px"
          />
        </div>
      </el-image>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    showDefaultImage: { type: Boolean, default: false },
  },
  data() {
    return { tableColumns: tableColumns(this) }
  },
}
</script>
